import { hillo } from 'hillo'
import { cloudV2Url } from '@/model/dataLayer/api/SaaS/SaaSUtils'
import IKDataEntity from '@/plugins/EntityFrameWork/IKDataEntity'
import GlobalConfig from '@/model/global/GlobalSettings'
import Asset from '@/model/dataLayer/api/MembershipSystem/Asset'

export const AwardClaimType = [{ label: 'OrderCount', value: 'OrderCount' }, { label: 'OrderAmount', value: 'OrderAmount' }, { label: 'ItemCount', value: 'ItemCount' }]

const entity = {
  description: {},
  awardMax: {
    displayName: '可兑奖数量',
    formConfig: {
      default: 10,
      hint: '积分可以兑换数量的最大值'
    }
  },
  awardStart: {
    displayName: '起始值',
    header: false,
    formConfig: {
      default: 1,
      required: false,
      hint: '奖励积分的起始值，通常为1，表示从1开始累积'
    }
  },
  assetId: {
    displayName: '资产',
    type: IKDataEntity.Types.Option,
    formConfig: {
      type: {
        showButton: true,
        selectItems: async () => { return await Asset.getList(true) },
        itemText: 'name',
        itemValue: 'id'
      }
    }
  },
  active: {
    type: IKDataEntity.Types.Boolean,
    formConfig: {
      required: false,
      default: true
    }
  },
  repeatable: {
    displayName: '可重复',
    type: IKDataEntity.Types.Boolean,
    formConfig: {
      required: false,
      default: true
    }
  },
  minOrderAmount: {
    displayName: '最小订单金额',
    header: false,
    formConfig: {
      default: 0,
      required: false,
      hint: '设置获得积分的最小订单金额，例如订单金额超过10欧才能获得积分'
    }
  },
  claimType: {
    header: false,
    displayName: '积分获取方式',
    type: IKDataEntity.Types.Option,
    formConfig: {
      required: false,
      hint: 'orderCount是一单一分，orderAmount是1欧一分，向下取整',
      default: 'OrderCount',
      type: {
        selectItems: AwardClaimType,
        itemText: 'label',
        itemValue: 'value'
      }
    }
  },
  pointClearAfterLastUsageDays: {
    displayName: '积分清除天数',
    header: false,
    formConfig: {
      default: 999,
      required: false,
      hint: '设置积分在最后一次使用后多少天自动清除，999表示基本不清除'
    }
  },
  allowExcessAccumulation: {
    displayName: '超额累积',
    type: IKDataEntity.Types.Boolean,
    formConfig: {
      default: false,
      required: false
    }
  }
}

const path = 'membership/award'

const config = {
  load: async function (filter) {
    return (await hillo.get(cloudV2Url + path + '/byBlId/' + GlobalConfig.blId)).map(it => {
      it.description = it.awardInfo.description
      it.awardMax = it.awardInfo.awardMax
      it.awardStart = it.awardInfo.awardStart
      it.assetId = it.awardInfo.assetId
      it.claimType = it.awardInfo.claimType
      it.minOrderAmount = it.awardInfo.minOrderAmount
      it.pointClearAfterLastUsageDays = it.awardInfo.pointClearAfterLastUsageDays
      it.allowExcessAccumulation = it.awardInfo.allowExcessAccumulation
      return it
    })
  },
  add: async function (item) {
    item.blId = GlobalConfig.blId
    return (await hillo.jsonPost(cloudV2Url + path + '/save', {
      ...item
    })).content
  },
  edit: async function (item) {
    return (await hillo.jsonPost(cloudV2Url + path + '/save', {
      ...item
    })).content
  },
  remove: async function (id) {
    return (await hillo.jsonPost(cloudV2Url + path + '/delete/' + id, {
    }))
  }
}

export default IKDataEntity.ModelFactory(entity, config)
